const PAN_CLICK_SUPPRESSION_MS = 500;

let suppressPanningClickUntil = 0;

const now = () => (
  typeof performance !== "undefined" && typeof performance.now === "function"
    ? performance.now()
    : Date.now()
);

export const markPanningDragFinished = () => {
  suppressPanningClickUntil = now() + PAN_CLICK_SUPPRESSION_MS;
};

export const consumeShouldSuppressClickAfterPanningDrag = () => {
  if (now() >= suppressPanningClickUntil) {
    return false;
  }

  suppressPanningClickUntil = 0;
  return true;
};
